module.exports = __webpack_public_path__ + "static/media/00.cfd0fd3e.jpg";